<template>
  <div>
    <div v-if="!detailBox">
      <div class="them" style="margin-top: 28px">
        <div class="line"></div>
        近{{ this.yearCount }}年业绩信息
      </div>
      <el-table :data="project" class="tableControll" empty-text="暂无数据">
        <el-table-column
          style="margin-left: 30px"
          type="index"
          label="序号"
          width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="year"
          label="年度"
          align="center"
        ></el-table-column>
        <el-table-column align="center" label="登记状态">
          <template>
            <span v-if="status == 1" class="green status">已登记</span>
            <span v-if="status == -1" class="red status">登记驳回</span>
            <span v-if="status == 0" class="blue status">登记中</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="project_count"
          label="年度项目数量(个)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="project_income"
          label="年度工程造价营业收入(万)"
          align="center"
        ></el-table-column>
        <el-table-column prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <span class="handle" @click="goDetail(scope.row)">查看详情</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 点击上面的查看详情后，再次出现的详情列表-->
    <div v-else>
      <div class="them" style="margin-top: 28px">
        <div class="line"></div>
        年度业绩信息
      </div>
      <div class="box">
        <div class="each">
          <div class="t">{{ detailYear }}年度项目总数</div>
          <div class="n">{{ detailCount }}</div>
        </div>
        <div class="cutOff"></div>
        <div class="each">
          <div class="t">年度工程造价营业收入(万)</div>
          <div class="n"><span>￥</span>{{ detailIncome }}</div>
        </div>
      </div>
      <el-table
        :data="detailProject"
        class="tableControll"
        empty-text="暂无数据"
      >
        <el-table-column
          style="margin-left: 30px"
          prop="date"
          label="序号"
          width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="name" label="项目名称" align="center">
        </el-table-column>
        <el-table-column align="center" label="项目起止时间 ">
          <template slot-scope="scope">
            {{ scope.row.start_time }} 至 {{ scope.row.finish_time }}
          </template>
        </el-table-column>
        <el-table-column prop="money" align="center" label="收费金额(万)">
        </el-table-column>
        <el-table-column align="center" label="操作" key="slot">
          <template #default="scope">
            <el-link @click="detailMini(scope.row)" style="font-size: 12px"
              >查看详情
            </el-link>
          </template>
        </el-table-column>
        <!--        <el-table-column align="center" label="操作" key="slot">-->
        <!--          <template>-->
        <!--            <el-link>查看详情</el-link>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
    </div>
    <!--    业绩信息的查看详情-->
    <!--    <AddYj-->
    <!--      :detailShow="true"-->
    <!--      :add.sync="dialogVisible"-->
    <!--      :idx="detail_row"-->
    <!--      :tableData.sync="project"-->
    <!--    />-->
    <el-dialog title="业绩详情" :visible.sync="yjDialog" width="540px">
      <div class="contControll">
        <div class="them"></div>
        <div class="cont">
          <div class="item">
            <div class="text">项目名称</div>
            <div class="detail">{{ line.name }}</div>
          </div>
          <div class="item">
            <div class="text">项目类型</div>
            <div class="detail">{{ line.type }}</div>
          </div>

          <div class="item">
            <div class="text">项目起止日期</div>
            <div class="detail">
              {{ line.start_time }}至{{ line.finish_time }}
            </div>
          </div>
          <div class="item">
            <div class="text">委托单位名称</div>
            <div class="detail">{{ line.company }}</div>
          </div>
          <div class="item">
            <div class="text">承接业务专业</div>
            <div class="detail">{{ line.service1 }}\{{ line.service2 }}</div>
          </div>
          <div class="item">
            <div class="text">项目造价/投资金额（万）</div>
            <div class="detail">{{ line.amount }}</div>
          </div>
          <div class="item">
            <div class="text">收费比例</div>
            <div class="detail">{{ line.ratio }}</div>
          </div>
          <div class="item">
            <div class="text">收费金额（万）</div>
            <div class="detail">
              {{ line.money }}
            </div>
          </div>
          <div class="item">
            <div class="text">收费时间</div>
            <div class="detail">{{ line.money_time }}</div>
          </div>
          <div class="item">
            <div class="text">发票号码</div>
            <div class="detail">{{ line.bill_code }}</div>
          </div>
          <div class="item">
            <div class="text">项目负责人</div>
            <div class="detail">{{ line.technical_name }}</div>
          </div>
          <div class="item">
            <div class="text">项目负责人联系电话</div>
            <div class="detail">{{ line.technical_tel }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="yjDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { enterprise } from "@/api/company.js";
import { deleteRow, performance_update } from "@/api/yj.js";
// import AddYj from "@/components/record/SkkCreatePer";

export default {
  name: "YjDetail",
  components: {
    // AddYj,
  },
  data() {
    return {
      tableData: [],
      performance: {}, //业绩详情
      yearCount: null,
      project: [],
      detailBox: false,
      dialogVisible: false,
      detail_row: -1, //当前这一行的详情
      year: "",
      status: null, //状态
      detailShow: false, //子组件 是否显示详情页
      edit: false, //是否是编辑 子组件是否需要显示老值
      idx: -1, //编辑需要知道是编辑表格的哪一行

      //最里面的详情
      detailYear: 0, //年度
      detailCount: 0, //项目总数量
      detailIncome: 0, //项目总收入
      detailProject: [], //项目

      yjDialog: false,
      line: {}, //每一行
    };
  },
  props: {
    //父组件recordDetail传过来的record_id
    detail: {
      type: Number,
      default: null,
    },
  },
  created() {
    this.init();
  },
  computed: {
    //年度工程数量
    project_count() {
      return this.project.length;
    },
    //年度工程营业收入
    project_income() {
      let income = 0;
      this.project.forEach((item) => {
        income += Number(item.money);
      });
      return income;
    },
  },
  methods: {
    async init() {
      // console.log(typeof this.detail);
      const res = await enterprise({ record_id: this.detail });
      this.performance = res.performance;
      this.year = res.year;
      const yearArr = this.year.split(",");
      this.yearCount = yearArr.length;
      if (this.yearCount == 1) {
        this.yearCount = "一";
      } else if (this.yearCount == 2) {
        this.yearCount = "两";
      } else {
        this.yearCount = "三";
      }
      this.project = res.performance;
      // this.project_count = res.performance.project_count;
      // this.project_income = res.performance.project_income;
      this.status = res.status;
    },
    goDetail(row) {
      this.detailBox = true;
      // console.log(row, "row------");
      this.detailYear = row.year;
      this.detailCount = row.project_count;
      this.detailIncome = row.project_income;
      this.detailProject = row.project;
    },
    //
    // smallBtn(row) {
    //   console.log(row);
    // },
    //最里面的详情
    detailMini(row) {
      //存放每一行的详情，传给子组件
      this.line = row; //每一行
      // console.log(this.line, "line");
      this.yjDialog = true;
      // this.detailShow = true;
    },
    //删除每一行
    async delectRowBtn(id, index) {
      // console.log(id);
      await deleteRow({ id: id });
      // console.log(index, "index");
      this.project.splice(index, 1);
      this.$message.success("删除成功！");
    },
    //编辑每一行
    editRowBtn(row, index) {
      this.dialogVisible = true;
      this.detail_row = row;
      this.detailShow = false;
      this.edit = true;
      this.idx = index;
    },
    //编辑更新业绩
    update_data() {
      let tem_project = [];
      this.project.forEach((item) => {
        delete item.pid;
        tem_project.push(item);
      });
      // console.log(tem_project, "tem_project");
      let params = {
        record_id: this.detail,
        project_count: this.project_count,
        project_income: this.project_income,
        project: tem_project,
      };
      // console.log(params, "打印参数");
      performance_update(params);
    },
  },
};
</script>

<style lang="less" scoped>
.them {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  color: #333333;
  padding-left: 15px;

  .line {
    width: 4px;
    height: 16px;
    background: #4379f6;
    left: 0px;
    position: absolute;
  }

  .des {
    font-size: 14px;
    color: #666666;
    margin-left: 20px;
    font-weight: 400;
  }
}

.box {
  width: 100%;
  height: 76px;
  background: #ffffff;
  border: 1px solid #e1e8f9;
  border-radius: 2px;
  box-shadow: 0px 0px 6px 0px rgba(151, 190, 255, 0.2);
  padding: 13px 0;
  box-sizing: border-box;
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .cutOff {
    width: 1px;
    height: 50px;
    background: #dddddd;
  }

  .each {
    flex: 1;
    text-align: center;

    .t {
      font-size: 12px;
      color: #666666;
    }

    .n {
      margin-top: 2px;
      font-size: 20px;
      color: #333333;
      font-family: "BEBAS";

      span {
        font-size: 14px;
        color: #333333;
      }
    }
  }
}

.tableControll {
  width: 100%;
  border: solid 1px rgb(235, 238, 245);
  border-bottom: unset;
  margin-top: 16px;

  .handle {
    font-size: 12px;
    color: #666666;
    margin-left: 20px;
    text-decoration: unset;

    &:first-child {
      margin-left: unset;
    }

    &:hover {
      color: #4379f6;
    }
  }

  .link {
    color: #666666;
    text-decoration: unset;

    &:hover {
      color: #4379f6 !important;
    }
  }

  .red {
    background: #f8eaea;
    color: #f32323;
  }

  .green {
    background: #e8f8e9;
    color: #25a22d;
  }

  .blue {
    background: #d2e7fb;
    color: #4496f1;
  }

  .status {
    font-size: 12px;
    padding: 2px;
  }
}

/deep/ .el-table th {
  background: #f6f6f6 !important;
  color: #666;
  font-weight: normal;
}

/deep/ .el-table tr {
  color: #333 !important;
  font-size: 12px;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #dddddd;
}

/deep/ .el-dialog__footer {
  background: #f5f5f5;
  height: 70px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
}

.dialog-footer {
  /deep/ .el-button--primary {
    width: 100px;
    background: #f39020;
  }

  /deep/ .el-button {
    padding: unset;
    width: 100px;
    height: 32px;
    border-radius: unset;
  }
}

.t {
  margin-top: 20px;
  font-size: 12px;
  color: #666666;
}

/deep/ .el-table__empty-text {
  line-height: unset;
}

.handle {
  font-size: 12px;
  color: #666666;
  margin-left: 20px;
  text-decoration: unset;
  cursor: pointer;

  &:first-child {
    margin-left: unset;
  }

  &:hover {
    color: #4379f6;
  }
}

.contControll {
  display: flex;
  align-items: flex-start;

  .them {
    font-size: 12px;
    font-weight: 700;
    color: #333333;
  }

  .cont {
    flex: 1;

    .item {
      display: flex;
      align-items: center;
      margin-top: 16px;

      &:first-child {
        margin-top: unset;
      }

      .text {
        font-size: 12px;
        color: #999999;
        min-width: 190px;
      }

      .detail {
        font-size: 12px;
        color: #333333;
        flex: 1;
      }

      .check {
        font-size: 12px;
        color: #4379f6;
        cursor: pointer;
      }
    }
  }
}
</style>
